import React from "react";

function CardDescription({ data, isApp }) {
  return (
    <div className={!isApp && "row mt-4 "}>
      <div className="clup-card">
        <div className="titre">
          <i
            className="fas fa-prescription-bottle-alt"
            style={{ fontSize: "25px", marginLeft: "5px" }}
          />
          <h6 className={isApp && "border-bottom pb-2 mb-2 w-100"}>توضیحات</h6>
        </div>
        <div className="row p-2">
          <p
            style={{
              fontWeight: "500",
            }}
          >
            چطوری امتیاز های خودم رو در نیکوتن افزایش بدم ؟
          </p>
        </div>
        <div className="row card-box">
          {data &&
            Object.keys(data).map((key, coutn) => {
              return <Cards key={coutn} score={data[key]} elemnt={key} />;
            })}
        </div>
      </div>
    </div>
  );
}

export default CardDescription;

const Cards = ({ score, elemnt }) => {
  const text = () => {
    switch (elemnt) {
      case "order":
        return `هربار که یک سفارش در نیکوتن انجام میدی به ازاری هر ${score.basedofscororder} تومان ${score.scorforbased}امتیاز دریافت میکنی ! `;
      case "comment":
        return ` شما در نیکوتن با اولین نظری که  برای هر مجموعه بزاری ${score.scorecomment} امتیاز دریفات میکنی پس برای هر مجموعه نظرتو بگو و امتیاز دریافت کن`;
      case "profile":
        return `با تکمیل پروفایلت ${score.scoreprofilecompelete} امتیاز دریافت میکنی`;
      case "invate":
        return `هر بار که دوستات با کد دعوت تو در سامانه نیکوتن ثبت نام میکنن ${score.scoreinvate} امتیاز دریافت میکنی`;
      case "app":
        return `راستی یادت باشه  با ثبت نام از طریق اپلیکیشن نیکوتن ${score.scoreappsingup} امتیاز دریافت میکنی . پس وقتی دوستاتو دعوت کردی بگو از طریق اپ ثبت نام کنه !`;
    }
  };
  return (
    <>
      <div className="col-md-8">
        <div className="d-flex  align-items-center p-2">
          <img src={window.origin + "/img/tikk.png"} alt="" width={"50px"} />
          <p
            style={{
              fontSize: "15px",
              fontWeight: "400",
            }}
          >
            {text()}
          </p>
        </div>
      </div>
      <div className="col-md-4 d-flex justify-content-end mt-5">
        <img
          src={score.image}
          alt={"وکتور برای " + elemnt}
          style={{ objectFit: "cover", maxHeight: "188px", maxWidth: "320px" }}
        />
      </div>
    </>
  );
};
